import Cookie from 'js-cookie';
import { CookieName } from '@/shared/enums';
import { getRandomHexString } from './random-string';

export default () => {
  let uid = Cookie.get(CookieName.DEVICE_UID);

  if (!uid) {
    uid = getRandomHexString();
    Cookie.set(CookieName.DEVICE_UID, uid);
  }

  return uid;
};
